import buildParams from "utilities/request/buildParams";
import _ from 'lodash';

export default function convert(urlParameters, traditional) {
	var prefix,
		s = [],
		add = function(key, valueOrFunction) {

			// If value is a function, invoke it and use its return value
			var value = typeof valueOrFunction === "function" ?
				valueOrFunction() :
				valueOrFunction;

			s[s.length] = encodeURIComponent(key) + "=" +
				encodeURIComponent(value == null ? "" : value);
		};

	if(urlParameters == null) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if(Array.isArray(urlParameters) || (!_.isObject(urlParameters))) {

		// Serialize the form elements
		_.each(urlParameters, function(value, name) {
			add(name, value);
		});

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for(prefix in urlParameters) {
			try {
				buildParams(prefix, urlParameters[prefix], traditional, add);
			} catch(error) {
				console.error(error);
				console.log({
					prefix, a: urlParameters, traditional
				});
				throw error;
			}
		}
	}

	// Return the resulting serialization
	const result = s.join("&");
	console.log('result', result);
	return result;
};